<template>


  <div id="dlnkpartners-partners" class="w-100">

    <dlnkalert
        :message="message"
        :message_type="message_type"
        @close="close_message()"
    ></dlnkalert>


    <!---- Partner modal ---->
    <div class="modal" id="partner_modal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <img :src="partner.logo" width="150px"/>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <p class="partenaire_text_modal" v-html="partner.description">
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">Fermer</button>
          </div>
        </div>
      </div>
    </div>
    <!--fin affiche modal-------->


    <div class="position-relative overflow-hidden bg-light">
      <div class="container position-relative z-index-2 space-top-1 space-top-md-2 space-bottom-1 space-bottom-md-2">
        <div class="w-md-80 mx-md-auto"><div class="mb-7">
          <h1 class="text-center text-primary">{{page.title}}</h1>
        </div>
          <p></p>
        </div>
      </div>
      <figure class="position-absolute right-0 bottom-0 left-0 mb-n1"><svg preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 1920 100.1"><path fill="#fff" d="M0,0c0,0,934.4,93.4,1920,0v100.1H0L0,0z"></path></svg></figure>
    </div>

    <!-- Stories Section -->
    <div class="container pt-4">

<!--      <p class="" v-html="page.description"></p>-->

      <div class="row">

        <div class="col-sm-6 col-md-4 mb-5" v-for="partner in partners">
          <div class="card h-100">
            <div class="card-body">
              <div class="max-w-13rem w-100 mb-3">
                <img class="img-fluid" :src="partner.logo"
                     alt="Logo">
              </div>

              <p class="mb-0">
                {{partner.short_description}}
              </p>

            </div>

            <div class="card-footer">

              <a class="font-weight-bold" href="javascript:void()" data-toggle='modal'
                 data-target='#partner_modal' @click="open_modal(partner)">
                En savoir plus <i class="fas fa-angle-right fa-sm ml-1"></i>
              </a>

              <a v-if="partner.url != null" class="font-weight-bold float-right"
                 :href="partner.url" target="_blank">
                Visiter le site web <i class="fas fa-angle-right fa-sm ml-1"></i>
              </a>
            </div>

          </div>
        </div>


      </div>

      <div class="text-center mt-5">
        <a class="btn btn-primary" href="#">Retour haut de page</a>
      </div>
    </div>
    <!-- End Stories Section -->





  </div>
</template>

<script>

export default {
  props: ['page_id'],

  data: function () {
    return {
      message: '',
      message_type: '',

      partners: Array,
      partner: Object,
      page: Object,

    }
  },
  mounted() {
    this.step = 'pages'
    this.get_page()
  },

  computed: {},

  methods: {
    close_message: function () {
      this.message = null;
    },

    open_modal: function (partner) {
      this.partner = partner
    },

    get_page: async function () {
      const _this = this;

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/partner_pages/" + _this.page_id + ".json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      axios.get(api_url)
          .then(function (response) {
            _this.page = response.data
            _this.partners = _this.page.partners
          })
          .catch(function (error) {
            _this.message = "Erreur";
            _this.message_type = "alert-danger"
          })
          .then(function () {
                // always executed
              }
          );
    },
  }
}
</script>

<style scoped>

.bg-blue {
  background-color: #0049a4;
}

</style>